// @flow
import { createBrowserHistory } from 'history'

import { initLogger } from 'utils/logger'
import type { ExternalProps } from './types'
import { FoxfordMenu } from './menuBuilder'

initLogger()

const history = createBrowserHistory()

type CreateConfig = {|
  ...$Exact<ExternalProps>,
  afterRender?: () => void, // функция которая вызовется после рендера меню
  beforeRender?: () => void, // функция которая вызовется до рендера меню
  onUnmount?: () => void, // функция которая вызовется до рендера меню
|}

const createMenu = (options: CreateConfig) => {
  try {
    const { afterRender, beforeRender, onUnmount, ...props } = options

    return new FoxfordMenu({
      options: props,
      history,
      afterRender,
      beforeRender,
      onUnmount,
    })
  } catch (error) {
    console.error(error) // eslint-disable-line
  }

  return null
}

export { createMenu }
